// This util to converts a Jane Delta format into Markdown for quick phrases/snippets.
export const convertJanePhraseDeltaToMarkdown = (delta: unknown) => {
  let md = '';
  if (
    typeof delta === 'object' &&
    delta !== null &&
    'ops' in delta &&
    Array.isArray(delta.ops)
  ) {
    for (const op of delta.ops) {
      let txt: string;
      if (typeof op.insert === 'string') {
        txt = op.insert;
      } else if (typeof op.insert === 'object' && op.insert.diagnosisCode) {
        const diag = op.insert.diagnosisCode;
        txt = `${diag.code} - ${diag.label}`;
      } else {
        continue;
      }
      md += txt;
    }
  }
  return md.trim();
};
